var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg013Breakfast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Glyph",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59,50H5a3,3,0,0,0,0,6H59a3,3,0,0,0,0-6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52,58.71A5.03078,5.03078,0,0,0,10.47,63H53.53a5.03078,5.03078,0,0,0,4.95-4.29l.1-.71H5.42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.14,48H58a1.003,1.003,0,0,0,1-1V44a8.99435,8.99435,0,0,0-5.27-8.18l-1.62.17a7.011,7.011,0,0,0-6.61,6.99,1,1,0,0,1-2,0A8.996,8.996,0,0,1,48.36,35H42.55A7.00589,7.00589,0,0,0,36,41.98a1,1,0,0,1-2,0A9.00042,9.00042,0,0,1,37.33,35H36a8.9083,8.9083,0,0,0-4.5,1.21V41A8.96015,8.96015,0,0,1,28.14,48Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,42H9.5799A7.005,7.005,0,0,0,16.5,48h6a7.00818,7.00818,0,0,0,7-7V30a3.00328,3.00328,0,0,0-3-3h-14a3.00328,3.00328,0,0,0-3,3h-3a4.00427,4.00427,0,0,0-4,4v4A4.00427,4.00427,0,0,0,6.5,42Zm-2-8a2.00229,2.00229,0,0,1,2-2h3v8h-3a2.00229,2.00229,0,0,1-2-2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9,21h6a2.50263,2.50263,0,0,1,2.5,2.5V24a1,1,0,0,0,2,0v-.5A4.50491,4.50491,0,0,0,15,19H9a2.5,2.5,0,0,1,0-5H26.5a4.5,4.5,0,0,0,0-9H20a2.50263,2.50263,0,0,1-2.5-2.5V2a1,1,0,0,0-2,0v.5A4.50491,4.50491,0,0,0,20,7h6.5a2.5,2.5,0,0,1,0,5H9a4.5,4.5,0,0,0,0,9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25,25a.99974.99974,0,0,0,1-1V23a5.00588,5.00588,0,0,0-5-5,1,1,0,0,0,0,2,3.00328,3.00328,0,0,1,3,3v1A.99974.99974,0,0,0,25,25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12,9a1,1,0,0,0,0-2,2.00229,2.00229,0,0,1-2-2V2A1,1,0,0,0,8,2V5A4.00427,4.00427,0,0,0,12,9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg013Breakfast);
export default __webpack_public_path__ + "static/media/013-breakfast.35312185630f1cd79ae77337e29a8b87.svg";
export { ForwardRef as ReactComponent };